import ComingSoon from '../components/ComingSoon';

const ComingSoonPage = () => {
    return (
        <div>
            <ComingSoon />
        </div>
    );
}

export default ComingSoonPage;